import { RouteObject, Navigate } from "react-router-dom";
import { AuthLayout } from "@/features/Auth";
import PageNotFound from "@/pages/404";
import ToMeNotification from "@/pages/Flow/ToMeNotification";

export const publicRoutes: RouteObject[] = [
  {
    path: "/auth/*",
    element: <AuthLayout />,
  },
  {
    path: "/404",
    element: <PageNotFound />,
  },
  {
    path: "/notification",
    element: <ToMeNotification />,
  },
];

export const notFoundRoute: RouteObject = {
  path: "*",
  element: <Navigate to="/404" replace />,
};
